import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { img, inr, offPct, useGet } from "@/lib/api";
import { useShop } from "@/lib/store";

export function ProductCard({ p, i = 0 }) {
  const { toggleWish, inWish } = useShop();
  const off = offPct(p);
  const wished = inWish(p.id);
  return (
    <div className="group reveal" style={{ animationDelay: `${i * 60}ms` }} data-testid={`product-card-${p.slug}`}>
      <div className="relative aspect-[3/4] overflow-hidden bg-[#171717]">
        <Link to={`/product/${p.slug}`} data-testid={`product-card-link-${p.slug}`}>
          <img src={img(p.images[0])} alt={p.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-700 group-hover:scale-105" />
          {p.images[1] && <img src={img(p.images[1])} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700" />}
        </Link>
        <div className="absolute top-3 left-3 flex flex-col gap-1.5 pointer-events-none">
          {off > 0 && <span className="bg-neon text-black text-[10px] font-bold px-2 py-1 font-mono">-{off}%</span>}
          {p.tags?.includes("limited") && <span className="bg-red-600 text-white text-[10px] font-bold px-2 py-1 font-mono">LIMITED</span>}
          {p.stock < 10 && <span className="bg-white text-black text-[10px] font-bold px-2 py-1 font-mono">{p.stock === 0 ? "SOLD OUT" : `ONLY ${p.stock} LEFT`}</span>}
        </div>
        <button onClick={() => toggleWish(p)} data-testid={`wishlist-toggle-${p.slug}`} aria-label="Wishlist"
          className={`absolute top-3 right-3 w-9 h-9 grid place-items-center backdrop-blur-md transition-colors ${wished ? "bg-neon text-black" : "bg-black/50 text-white hover:bg-white hover:text-black"}`}>
          <Heart className="w-4 h-4" fill={wished ? "currentColor" : "none"} />
        </button>
        <Link to={`/product/${p.slug}`} className="absolute bottom-0 inset-x-0 bg-neon text-black text-center text-xs font-bold tracking-[.2em] py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">VIEW & ADD TO CART</Link>
      </div>
      <div className="pt-4 space-y-1.5">
        <div className="flex justify-between gap-3">
          <Link to={`/product/${p.slug}`} className="text-sm font-semibold leading-snug hover:text-neon transition-colors line-clamp-1">{p.title}</Link>
          {p.rating > 0 && <span className="text-[11px] text-grey flex items-center gap-1 shrink-0"><Star className="w-3 h-3 fill-current text-neon" />{Number(p.rating).toFixed(1)}</span>}
        </div>
        <div className="flex items-baseline gap-2 font-mono text-sm">
          <span className="text-white font-semibold" data-testid={`product-price-${p.slug}`}>{inr(p.effective_price || p.price)}</span>
          {p.sale_price && <span className="text-grey line-through text-xs">{inr(p.price)}</span>}
        </div>
      </div>
    </div>
  );
}

export function ProductGrid({ items, cols = "grid-cols-2 md:grid-cols-3 lg:grid-cols-4" }) {
  return <div className={`grid ${cols} gap-x-4 gap-y-10 sm:gap-x-6`}>{items.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}</div>;
}

export function ProductRail({ query }) {
  const { data = [], isLoading } = useGet(`/products?${query}`);
  if (isLoading) return <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">{[0, 1, 2, 3].map((i) => <div key={i} className="aspect-[3/4] bg-[#171717] animate-pulse" />)}</div>;
  return <ProductGrid items={data.slice(0, 8)} />;
}
